const PDFIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5610_884)">
        <path
          d="M11.9877 17.9864C15.283 17.9864 17.9549 15.315 17.9549 12.0192C17.9549 8.72341 15.2835 6.052 11.9877 6.052C8.69191 6.052 6.02051 8.72341 6.02051 12.0192C6.02051 15.315 8.69191 17.9864 11.9877 17.9864Z"
          fill="white"
        />
        <path
          d="M6.81965 15.0038L1.65309 6.05493C0.60543 7.86899 0.0537109 9.92681 0.0537109 12.0216C0.0537109 14.1165 0.604961 16.1743 1.65262 17.9884C2.70027 19.8024 4.20684 21.3085 6.02137 22.3557C7.8359 23.4029 9.89371 23.9537 11.9886 23.9532L17.1551 15.0038V15.0024C16.632 15.9099 15.8787 16.6637 14.9717 17.1877C14.0646 17.7118 13.0357 17.9879 11.9881 17.9879C10.9404 17.9879 9.91152 17.7123 9.00402 17.1887C8.09652 16.6651 7.34324 15.9113 6.81965 15.0038Z"
          fill="url(#paint0_linear_5610_884)"
        />
        <path
          d="M17.1543 15.0038L11.9877 23.9527C14.0825 23.9531 16.1404 23.4019 17.9544 22.3542C19.7685 21.307 21.275 19.8005 22.3222 17.9864C23.3694 16.1724 23.9207 14.1141 23.9202 12.0192C23.9197 9.92439 23.368 7.86657 22.3199 6.05298H11.9868L11.9854 6.05392C13.033 6.05345 14.0624 6.3286 14.9694 6.8522C15.8769 7.37579 16.6302 8.12907 17.1543 9.0361C17.6783 9.94314 17.9539 10.9725 17.9539 12.0202C17.9544 13.0674 17.6783 14.0963 17.1543 15.0038Z"
          fill="url(#paint1_linear_5610_884)"
        />
        <path
          d="M11.9877 16.7443C14.5968 16.7443 16.7118 14.6293 16.7118 12.0202C16.7118 9.41114 14.5968 7.29614 11.9877 7.29614C9.37867 7.29614 7.26367 9.41114 7.26367 12.0202C7.26367 14.6293 9.37867 16.7443 11.9877 16.7443Z"
          fill="#1A73E8"
        />
        <path
          d="M11.9869 6.05337H22.3205C21.2733 4.23884 19.7667 2.73228 17.9527 1.68509C16.1386 0.637432 14.0808 0.0861816 11.9859 0.0861816C9.8911 0.0861816 7.83328 0.6379 6.01922 1.68556C4.20516 2.73321 2.69906 4.24024 1.65234 6.05431L6.81891 15.0037L6.82031 15.0046C6.29625 14.0976 6.01969 13.0687 6.01969 12.021C6.01969 10.9734 6.29484 9.94399 6.81844 9.03696C7.34203 8.12946 8.09531 7.37618 9.00281 6.85259C9.90985 6.32853 10.9392 6.0529 11.9869 6.05337Z"
          fill="url(#paint2_linear_5610_884)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5610_884"
          x1="13.2793"
          y1="23.2079"
          x2="2.94526"
          y2="5.30881"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1E8E3E" />
          <stop offset="1" stop-color="#34A853" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5610_884"
          x1="10.2463"
          y1="23.9844"
          x2="20.5803"
          y2="6.08534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FCC934" />
          <stop offset="1" stop-color="#FBBC04" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5610_884"
          x1="1.65228"
          y1="7.54539"
          x2="22.3203"
          y2="7.54539"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D93025" />
          <stop offset="1" stop-color="#EA4335" />
        </linearGradient>
        <clipPath id="clip0_5610_884">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PDFIcon;
